import { render, staticRenderFns } from "./water_instant.vue?vue&type=template&id=4ab96765&"
import script from "./water_instant.vue?vue&type=script&lang=js&"
export * from "./water_instant.vue?vue&type=script&lang=js&"
import style0 from "./water_instant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports